export default "__VITE_ASSET__Civ8wd9A__"